/* FAVOURITE REDUX — list of organization objects */
const favourites = (state = [], action) => {

    switch (action.type) {

        case 'INIT_FAVOURITE':
            return action.payload

        case 'ADD_FAVOURITE':
            return [...state, action.payload]

        case 'REMOVE_FAVOURITE':
            return state.filter(item => item.id !== action.payload.id)

        case 'CLEAR_FAVOURITE':
            return []

        default:
            return state
    }
}

export default favourites
